import type { CreateProfessionInput, UpdateProfessionInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  PaginatedProfessions,
  ProfessionAdminRow,
  ProfessionsAdminParams
} from '../models/profession-admin'

export async function getProfessionsAdmin(
  params: ProfessionsAdminParams
): Promise<PaginatedProfessions> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedProfessions>(
    `${API.professions.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createProfession(
  payload: CreateProfessionInput
): Promise<ProfessionAdminRow> {
  const { data } = await axiosPrivate.post<ProfessionAdminRow>(API.professions.root, payload)
  return data
}

export async function updateProfession(
  id: string,
  payload: UpdateProfessionInput
): Promise<ProfessionAdminRow> {
  const { data } = await axiosPrivate.patch<ProfessionAdminRow>(API.professions.byId(id), payload)
  return data
}

export async function deleteProfession(id: string) {
  const { data } = await axiosPrivate.delete(API.professions.byId(id))
  return data
}
